import { css, cx } from "@emotion/css";
import { ValuePx, ValueRem } from "./Value";

export const LayoutRow: React.FC<{
  className?: Parameters<typeof cx>[0];
  reverse?: boolean;
  gap?: ValueRem | `${ValueRem} ${ValueRem}`;
  evenSplit?: number;
  itemMinWidth?: ValuePx;
  itemBorder?: string;
  colIfAtMost?: ValuePx;
  alignX?: "center" | "start" | "end";
  alignY?: "center" | "start" | "end";
}> = (props) => {
  let flexBasis;
  if (props.evenSplit != null && props.itemMinWidth != null) {
    flexBasis = `max(${props.itemMinWidth}, ${100 / props.evenSplit}%)`;
  } else if (props.evenSplit != null) {
    flexBasis = `${100 / props.evenSplit}%`;
  } else if (props.itemMinWidth != null) {
    flexBasis = props.itemMinWidth;
  }

  return (
    <div
      className={cx(
        css`
          label: LayoutRow;
          display: flex;
          flex-direction: ${props.reverse ? "row-reverse" : "row"};
          flex-wrap: ${props.itemMinWidth != null ? "wrap" : undefined};
          justify-content: ${props.alignX};
          align-items: ${props.alignY};
          gap: ${props.gap};
          border: ${props.itemBorder};
          border-right: 0;
          border-bottom: 0;

          @media (max-width: ${props.colIfAtMost}) {
            flex-wrap: wrap;
          }

          & > * {
            box-sizing: border-box;
            flex-basis: ${flexBasis};
            flex-shrink: ${props.itemMinWidth != null ? 0 : undefined};
            flex-grow: ${props.evenSplit != null ? 1 : undefined};
            border: ${props.itemBorder};
            border-left: ${props.itemBorder && 0};
            border-top: ${props.itemBorder && 0};

            @media (max-width: ${props.colIfAtMost}) {
              flex-basis: 100%;
            }
          }
        `,
        props.className,
      )}
    >
      {props.children}
      {props.evenSplit != null &&
        props.itemMinWidth != null &&
        new Array(props.evenSplit - 1).fill(null).map((_, i) => (
          <span
            className={css`
              * > & {
                border: none;
              }
            `}
            key={i}
          />
        ))}
    </div>
  );
};
